import { fetchFontList } from '../textFontFamily/apis';

let teamFontIds: number[] = [];
let hasInitTeamFontIds = false;
let refreshTeamFontIdsPromise: Promise<number[]> | null = null;

export const refreshTeamFontIds = async (): Promise<number[]> => {
    const teamFonts = await fetchFontList({ onlyFetchTeamFonts: true });
    teamFontIds = teamFonts.map((category) => category.materials.map((material) => material.id)).flat();
    return teamFontIds;
};

/** 可以调用无数次, 但不会重复调用接口 */
export const initTeamFontIds = async (): Promise<number[]> => {
    if (hasInitTeamFontIds) return teamFontIds;
    hasInitTeamFontIds = true;
    if (!refreshTeamFontIdsPromise) {
        refreshTeamFontIdsPromise = refreshTeamFontIds();
    }
    teamFontIds = await refreshTeamFontIdsPromise;
    return teamFontIds;
};

export const checkFontIdIsTeamFontId = (fontId: number) =>
    // 后端定的一个id范围, 普通字体id不会落到这个范围内, 但素材id可能会落到这个范围内, 所以传进来的id必须是字体id
    fontId >= 10000000 && fontId <= 19999999;

export const checkIsTeamFontId = async (materialId: number) => {
    if (!checkFontIdIsTeamFontId(materialId)) return false;
    const teamFontIds = await initTeamFontIds();
    return teamFontIds.includes(materialId);
};
